// assets/es-cart-ajax.js
// Cart page instant quantity/remove controls (2026-07-30). Replaces the old plain number input +
// separate "Update Cart" submit button (a full-page form POST/reload on every quantity change --
// see the comment in templates/cart.liquid for the full "why this felt slow" writeup) with direct
// calls to Shopify's own /cart/change.js and /cart/update.js endpoints. Only does anything on the
// real /cart page (guarded by #es-cart-root existing).
(function () {
  var root = document.getElementById('es-cart-root');
  if (!root) return;

  function money(cents) {
    var fmt = window.ES_MONEY_FORMAT || (window.Shopify && Shopify.money_format);
    return (window.Shopify && Shopify.formatMoney && fmt)
      ? Shopify.formatMoney(cents, fmt)
      : '$' + (cents / 100).toFixed(2);
  }

  function updateHeaderBadge(count) {
    document.querySelectorAll('.es-cart-badge').forEach(function (badge) {
      // Wishlist has its own independent badge (es-wishlist-badge) -- never touch it here.
      if (badge.classList.contains('es-wishlist-badge')) return;
      badge.textContent = count > 0 ? String(count) : '';
      badge.classList.toggle('es-cart-badge--visible', count > 0);
    });
  }

  // Re-number data-line after any add/remove -- Shopify's /cart/change.js "line" param is a
  // 1-based POSITIONAL index into cart.items, so removing row 2 makes the old row 3 into the
  // new row 2. Keeping every remaining row's data-line in sync with real DOM order is what lets
  // every later click still hit the correct cart line without a full page reload.
  function renumberRows() {
    var rows = root.querySelectorAll('#es-cart-items-body > .es-cart-row');
    rows.forEach(function (row, i) {
      var line = i + 1;
      row.setAttribute('data-line', line);
      var stepper = row.querySelector('.es-cart-qty-stepper');
      var input = row.querySelector('.es-cart-qty-input');
      var removeBtn = row.querySelector('.es-remove-item');
      if (stepper) stepper.setAttribute('data-line', line);
      if (input) input.setAttribute('data-line', line);
      if (removeBtn) removeBtn.setAttribute('data-line', line);
    });
  }

  function setRowBusy(row, busy) {
    var stepper = row.querySelector('.es-cart-qty-stepper');
    var removeBtn = row.querySelector('.es-remove-item');
    if (stepper) stepper.classList.toggle('is-updating', busy);
    if (removeBtn) removeBtn.disabled = busy;
  }

  function changeLine(row, line, quantity) {
    setRowBusy(row, true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) {
          // Whole cart is now empty -- that's a genuinely different layout (empty-state card
          // instead of the item table), simplest correct thing is a real reload rather than
          // hand-rolling a client-side swap for a rare edge case.
          window.location.reload();
          return;
        }

        var item = cart.items[line - 1];

        if (quantity === 0 || !item) {
          // This row was removed; every row after it just shifted up one line number.
          row.classList.add('es-cart-row--removing');
          setTimeout(function () {
            row.remove();
            renumberRows();
          }, 200);
        } else {
          var input = row.querySelector('.es-cart-qty-input');
          var lineTotal = row.querySelector('.es-cart-line-total');
          if (input) input.value = item.quantity;
          if (lineTotal) lineTotal.textContent = money(item.line_price);
          setRowBusy(row, false);
        }

        var totalEl = document.querySelector('.es-cart-total-price');
        if (totalEl) totalEl.textContent = money(cart.total_price);
        updateHeaderBadge(cart.item_count);
      })
      .catch(function () {
        setRowBusy(row, false);
      });
  }

  root.addEventListener('click', function (e) {
    var minus = e.target.closest('.es-cart-qty-minus');
    var plus = e.target.closest('.es-cart-qty-plus');
    var remove = e.target.closest('.es-remove-item');

    if (minus || plus) {
      var stepper = (minus || plus).closest('.es-cart-qty-stepper');
      if (stepper.classList.contains('is-updating')) return;
      var row = stepper.closest('.es-cart-row');
      var input = stepper.querySelector('.es-cart-qty-input');
      var line = parseInt(stepper.getAttribute('data-line'), 10);
      var qty = parseInt(input.value, 10) || 1;
      qty = minus ? Math.max(0, qty - 1) : qty + 1;
      changeLine(row, line, qty);
      return;
    }

    if (remove) {
      if (remove.disabled) return;
      var row = remove.closest('.es-cart-row');
      var line = parseInt(remove.getAttribute('data-line'), 10);
      changeLine(row, line, 0);
    }
  });

  // Manually typed quantity (not just +/-)
  root.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('es-cart-qty-input')) return;
    var input = e.target;
    var stepper = input.closest('.es-cart-qty-stepper');
    var row = input.closest('.es-cart-row');
    var line = parseInt(input.getAttribute('data-line'), 10);
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 1;
    changeLine(row, line, qty);
  });

  // Cart note -- save on blur instead of relying on a form submit that no longer exists.
  var noteField = document.getElementById('es-cart-note');
  if (noteField) {
    noteField.addEventListener('change', function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteField.value })
      });
    });
  }

  // Relocate the ShipInsure widget (loaded by a global third-party script, not this template)
  // to sit inside our own "Protect Your Order" note instead of wherever its generic
  // nearest-checkout-button heuristic happens to attach it -- see the comment in
  // templates/cart.liquid. ShipInsure re-checks/re-injects on a timer after load, so this uses
  // a MutationObserver rather than a one-off timeout to catch it whenever it actually appears.
  var protectionNote = document.querySelector('.es-cart-shipinsure-note');
  if (protectionNote) {
    // NOTE: an earlier version of this file auto-clicked the checkbox on here (ShipInsure
    // defaults the cart widget to opted OUT). Reverted 2026-08-03 -- turning it off on the live
    // cart page causes a full page reload (not an AJAX update, confirmed live: the tab's JS
    // context is destroyed on toggle-off), which re-ran this script from scratch and re-clicked
    // it back on every time, making the checkbox impossible to turn off. Needs a real root-cause
    // fix (why does toggle-off reload the page at all -- likely something in ShipInsure's own
    // cart-page integration, not the drawer/AJAX path) before auto-opt-in is safe to re-add.
    var placeShipInsureWidget = function () {
      var widget = document.querySelector('.shipinsure');
      if (!widget) return;
      if (widget.parentElement !== protectionNote) {
        protectionNote.appendChild(widget);
      }
    };
    placeShipInsureWidget();
    new MutationObserver(placeShipInsureWidget).observe(document.body, { childList: true, subtree: true });
  }
})();
